import TranslationText from '@Components/Utilities/TranslationText';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';;

const SimpleHomeBreadcrumb = (props) => {
    const currentSite = useRecoilValue(atoms.currentWebsite)
    return (

        <span>
            {!currentSite.IsMobileAppContext &&
                <div className='breadcrumbs'>
                    <a className='breadcrumbs__link uppercase' href={props.homeRoute}><TranslationText tKey='sandhills.tradepubwebsite.mvc.home' />&nbsp;&gt;&nbsp;</a>
                    <p className='breadcrumbs__link uppercase'>{props.displayText}</p>
                </div>
            }
        </span>
    );
};

export default SimpleHomeBreadcrumb;